module.exports = __webpack_public_path__ + "img/op.353767c3.png";